import { DeductionsSortOptions, Sort } from 'state';
import { DropDownButton } from 'components/Buttons/DropDownButton/DropDownButton';
import styles from './DeductionSortFilter.module.scss';

type Props = {
    deductionSort: Sort | undefined,
    onDeductionSortChange: (value: Sort) => void
};

const DeductionSortFilter = ({ deductionSort, onDeductionSortChange: onStatusChange }: Props) => (
    <DropDownButton 
        className={styles.control}
        items={DeductionsSortOptions}
        onItemClick={(e) => onStatusChange(e.item === 'Sort By' ? undefined : e.item)}
        tabIndex={0}
        text={<span className={styles.text}>{deductionSort?.text}</span>}
    />
);
export default DeductionSortFilter;